/** El sistema de créditos de eD2k, visto desde nuestro lado.
 *
 *  No hay una puntuación global: cada cliente al que le pedimos algo calcula un
 *  MODIFICADOR para nosotros con lo que le hemos subido A ÉL, y multiplica por él nuestro
 *  tiempo de espera en su cola. Esta es esa fórmula —`CClientCredits::GetScoreRatio` en
 *  aMule, la misma de eMule— aplicada desde su punto de vista: lo que él «bajó» de
 *  nosotros es lo que nosotros le subimos. Es una estimación: él la calcula con SUS
 *  contadores, que coinciden con los nuestros salvo pérdidas de identificación. */

/** Por debajo de un millón de bytes subidos no hay crédito. Es decimal a propósito: así lo
 *  escribe aMule (`< 1000000`), mientras que la raíz de abajo usa el megabyte binario. */
export const MINIMO_PARA_CREDITO = 1_000_000;

export function modificadorDeCredito(subidoAEl: number, bajadoDeEl: number): number {
  if (subidoAEl < MINIMO_PARA_CREDITO) return 1;
  const porIntercambio = bajadoDeEl === 0 ? 10 : (subidoAEl * 2) / bajadoDeEl;
  const porVolumen = Math.sqrt(subidoAEl / 1_048_576 + 2);
  const r = Math.min(porIntercambio, porVolumen);
  return Math.max(1, Math.min(10, r));
}

/** Tenemos crédito con él cuando el modificador supera el 1 que recibe cualquiera. */
export function tieneCredito(subidoAEl: number, bajadoDeEl: number): boolean {
  return modificadorDeCredito(subidoAEl, bajadoDeEl) > 1;
}
